if (!customElements.get("quick-atc")) {
	customElements.define(
		"quick-atc",
		class QuickAddtoCart extends HTMLElement {
			constructor() {
				super();
				this.loaderIcon = this.querySelector("[js-spinner-icon]");
				this.plusIcon = this.querySelector("[js-plus-icon]");
				this.init();
			}

			init() {
				this.addEventListener("click", (e) => {
					e.preventDefault();
					this.plusIcon.classList.add("hidden");
					this.loaderIcon.classList.remove("hidden");
					let productUrl = this.dataset.productUrl;

					document
						.querySelector("[js-quickatc-popup-wrapper]")
						.setAttribute("data-bundle-product", false);
					if (this.dataset.bundleProduct == "true") {
						productUrl = `${productUrl}?view=bundle`;
						document
							.querySelector("[js-quickatc-popup-wrapper]")
							.setAttribute("data-bundle-product", true);
					}
					this.renderProduct(productUrl);
				});
			}
			async renderProduct(productUrl) {
				try {
					const response = await fetch(`${location.origin}${productUrl}`);
					const html = await response.text();
					const html_ = new DOMParser().parseFromString(html, "text/html");
					const productGrid = html_.querySelector("[js-product-info]");

					productGrid
						.querySelector("product-info")
						.setAttribute("data-update-url", "false");

					if (productGrid) {
						const targetElement = document.querySelector(
							".quickatc-popup__content"
						);
						const parentTargetEle = targetElement.closest(
							".quickatc-popup__wrap"
						);
						if (targetElement) {
							targetElement.replaceChildren(productGrid);
							parentTargetEle.classList.add("active");
						}
					}

					document.dispatchEvent(new CustomEvent("quickAtcModelSlider:init"));
					document.dispatchEvent(new CustomEvent("pdp-accordion:init"));
					document.dispatchEvent(new CustomEvent("variantDropDown:init"));
					window.yotpoWidgetsContainer?.initWidgets();

					window.affirm?.ui?.refresh();
				} catch (error) {
					console.error("Error fetching product details:", error);
				} finally {
					this.loaderIcon.classList.add("hidden");
					this.plusIcon.classList.remove("hidden");
				}
			}
		}
	);
}
